module.exports = __webpack_public_path__ + "static/image06-800-359f7ce9b0558c3bff2d0f9929ca2925.jpg";